import { useEffect, useRef, useState } from "react";

export default function MultiplexAd() {
  const [shouldRender, setShouldRender] = useState(false);
  const adRef = useRef(null);
  const adLoaded = useRef(false); // sprečava ponovni push()

  useEffect(() => {
    if (window.innerWidth <= 1200) return;

    setShouldRender(true);

    // Dodaj AdSense skriptu ako nije već učitana
    if (!document.querySelector('script[src*="adsbygoogle.js"]')) {
      const script = document.createElement("script");
      script.src =
        "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3520542236575841";
      script.async = true;
      script.crossOrigin = "anonymous";
      document.head.appendChild(script);
    }

    const loadAd = () => {
      try {
        if (window.adsbygoogle && adRef.current && !adLoaded.current) {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          adLoaded.current = true;
        }
      } catch (e) {
        console.warn("AdSense not ready:", e);
      }
    };

    // malo kašnjenje da bi skripta sigurno bila spremna
    const timeout = setTimeout(loadAd, 800);

    return () => clearTimeout(timeout);
  }, []);

  if (!shouldRender) return null;

  return (
    <div style={{ margin: "2rem 0", textAlign: "center" }}>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: "inline-block", width: "800px", height: "400px" }}
        data-ad-client="ca-pub-3520542236575841"
        data-ad-slot="2389583558"
      ></ins>
    </div>
  );
}
